import { teacupWithHelpers } from 'app/scripts/views/internal/teacupWithHelpers';

// eslint-disable-next-line @trello/no-module-logic
const t = teacupWithHelpers('header_public_board');

export const template = () =>
  t.p('.u-bottom', function () {
    t.mustacheBlock('interactionText', () =>
      t.span('.u-inline-block', () => t.text(t.mustacheVar('interactionText'))),
    );
    return t.span('.u-inline-block', () =>
      t.a(
        {
          class: 'nch-button nch-button--primary',
          href: t.mustacheVar('signupUrl'),
        },
        () => t.format(t.mustacheVar('ctaKey')),
      ),
    );
  });
